module.exports = __webpack_public_path__ + "img/denmark.6faa90be.svg";